export * from './types';

import type { AxiosInstance, AxiosResponse } from 'axios';
import type { ISlideData } from '@/entities';
import type { IApiResponse } from '@/services';
import type { IApiSlideResponse } from '@/services';
import { mapApiSlide } from '@/mappers/slide';

export class ApiSlideEndpoint {
  axios: AxiosInstance;

  constructor(axiosInstance: AxiosInstance) {
    this.axios = axiosInstance;
  }

  async fetchSlides(
    locale: string,
    accountType: string | undefined,
    account: string | undefined
  ): Promise<ISlideData[]> {
    const url = `slides?locale=${encodeURIComponent(locale)}&accountType=${encodeURIComponent(
      accountType || ''
    )}&account=${encodeURIComponent(account || '')}`;

    const response: AxiosResponse<IApiResponse<IApiSlideResponse[]>> = await this.axios
      .get(url)
      .catch(() => Promise.reject());

    if (response?.data.data) {
      return response.data.data.map((s) => mapApiSlide(s));
    }

    return Promise.reject();
  }
}
